import { useState, useEffect, useContext, useRef } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiAvatar from "components/SuiAvatar";
import Tooltip from "@mui/material/Tooltip";
import SuiButton from "components/SuiButton";

// Images
import ImgCrop from "antd-img-crop";
import { Upload } from "antd";
import { getBase64, dataURLtoFile, beforeUpload } from "utils/imageHelper";
import toast from "react-hot-toast";

import { StoreContext } from "context/store";

import api from "services/api";

const Header = () => {
  const [imageUrl, setImageUrl] = useState("");
  const [inputWidth, setInputWidth] = useState(20);
  const [editNameVisible, setEditNameVisible] = useState(false);

  const { store, updateStore } = useContext(StoreContext);
  const storeNameInputRef = useRef(null);

  useEffect(() => {
    setImageUrl(store?.metadata?.avatar);
  }, [store]);

  const handleUploadImages = ({ file }) => {
    return getBase64(file);
    // return api.uploads.create([file])
  };
  const handleCropImgOk = async (data) => {
    const url = await getBase64(data);
    setImageUrl(url);
  };

  const handleSaveAvatar = async () => {
    try {
      let url = imageUrl;
      if (imageUrl?.startsWith("data")) {
        const file = dataURLtoFile(imageUrl, "company_avatar");

        const uploadedImg = await api.uploads.create([file]).then(({ data }) => {
          const uploaded = data.uploads.map(({ url }) => url);
          return uploaded;
        });
        url = uploadedImg && uploadedImg.length > 0 ? uploadedImg[0] : "";
      }

      const payload = {
        metadata: {
          avatar: url,
        },
      };
      await updateStore(payload);
      toast.success("Update avatar successfully!");
    } catch (err) {
      toast.error("Update avatar failed");
    }
  };

  const handleChangeStoreName = async () => {
    let value = storeNameInputRef?.current?.value || "";
    value = value.trim();
    if (value == store?.name || !value) {
      setEditNameVisible(false);
      return;
    }
    try {
      const payload = {
        name: value,
      };
      await updateStore(payload);
      toast.success("Store name has been successfully updated!");
    } catch (err) {
      console.log(err);
      toast.error("Store name could not be updated!");
    }
    setEditNameVisible(false);
  };

  const handleShowEditStoreName = () => {
    setEditNameVisible(true);
    setInputWidth(store?.name?.length);
  };

  return (
    <Card id="profile">
      <SuiBox className="p-2">
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <ImgCrop rotate shape="round" onModalOk={handleCropImgOk}>
              <Upload
                name="avatar"
                className="hover:cursor-pointer flex items-center"
                showUploadList={false}
                customRequest={handleUploadImages}
                beforeUpload={beforeUpload}
              >
                <Tooltip title={"Click to change"} placement="top">
                  {imageUrl ? (
                    <SuiAvatar
                      src={imageUrl}
                      alt="profile-image"
                      variant="circle"
                      size="xl"
                      shadow="sm"
                    />
                  ) : (
                    <SuiAvatar alt="profile-image" variant="circle" size="xl" shadow="sm" />
                  )}
                </Tooltip>
              </Upload>
            </ImgCrop>
          </Grid>
          <Grid item>
            <SuiBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%" }}
            >
              {editNameVisible ? (
                <div className="flex">
                  <input
                    size="small"
                    defaultValue={store.name}
                    ref={storeNameInputRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleChangeStoreName();
                      }
                    }}
                    className="font-serif"
                    autoFocus
                    style={{
                      outline: "none",
                      border: "none",
                      width: inputWidth + "ch",
                      fontSize: "1.25rem",
                      lineHeight: 1.375,
                      fontWeight: 700,
                    }}
                    onChange={(e) => setInputWidth(e.target?.value?.length)}
                    onBlur={handleChangeStoreName}
                  />
                </div>
              ) : (
                <SuiBox display="flex" alignItems="center" justifyContent="center" gap={1}>
                  <Tooltip title={"Click to change name"}>
                    <SuiTypography
                      variant="h5"
                      className="font-serif"
                      fontWeight="bold"
                      textTransform="none"
                      onClick={handleShowEditStoreName}
                    >
                      {store.name}
                    </SuiTypography>
                  </Tooltip>
                </SuiBox>
              )}
            </SuiBox>
          </Grid>
          {store?.metadata?.avatar != imageUrl ? (
            <Grid item xs={12} md={6} lg={3} sx={{ ml: "auto" }}>
              <SuiBox
                display="flex"
                justifyContent={{ md: "flex-end" }}
                alignItems="center"
                lineHeight={1}
              >
                <SuiBox mx={1}>
                  <SuiButton
                    variant="gradient"
                    color="light"
                    sx={{ height: "100%" }}
                    onClick={() => setImageUrl(store?.metadata?.avatar)}
                  >
                    reset
                  </SuiButton>
                </SuiBox>
                <SuiBox mx={1}>
                  <SuiButton
                    variant="gradient"
                    color="dark"
                    sx={{ height: "100%" }}
                    onClick={handleSaveAvatar}
                  >
                    save
                  </SuiButton>
                </SuiBox>
              </SuiBox>
            </Grid>
          ) : null}
        </Grid>
      </SuiBox>
    </Card>
  );
};

export default Header;
